import { Word } from '../../modules/material/_api/MedialinksApi';

type Header = {
  id: string;
  level: number;
  title: string;
  amount: number;
  attachedWords: Word[];
};

export type WordHierarchy = Record<string, Header>;

const createHeader = (id: string, level: number, title: string, amount = 0, attachedWords: Word[] = []): Header => ({
  id,
  level,
  title,
  amount,
  attachedWords,
});

const addWordToHeader = (header: Header, word: Word): Header => {
  const { amount, attachedWords } = header;

  return {
    ...header,
    amount: amount + 1,
    attachedWords: word ? [...attachedWords, word] : attachedWords,
  };
};

const incrementAmount = (header: Header): Header => {
  const { amount } = header;

  return {
    ...header,
    amount: amount + 1,
  };
};

export function buildWordHierarchy(words: Word[] = [], moduleName: string): WordHierarchy {
  const wordHierarchy: WordHierarchy = {};

  const processWord = (wordHierarchy: WordHierarchy, word: Word) => {
    const { nodeId, hierarchy } = word;

    if (nodeId === 'general') {
      const generalHeader = wordHierarchy[nodeId] || createHeader(nodeId, 1, moduleName);

      const updatedGeneralHeader = addWordToHeader(generalHeader, word);

      wordHierarchy[nodeId] = updatedGeneralHeader;
    } else if (hierarchy) {
      hierarchy.reduce((wordHierarchy, current, idx) => {
        const { id, prefix, displayPrefix, title } = current;

        const currentHeader =
          wordHierarchy[id] || createHeader(id, idx + 1, displayPrefix ? `${prefix} ${title}` : title);

        const updatedHeader =
          idx === hierarchy.length - 1 ? addWordToHeader(currentHeader, word) : incrementAmount(currentHeader);

        wordHierarchy[id] = updatedHeader;

        return wordHierarchy;
      }, wordHierarchy);
    }

    return wordHierarchy;
  };

  return words.reduce(processWord, wordHierarchy);
}
